import { Dispatch } from "../types/types";
import { request } from "../helpers/httpInterceptor";
import h from "../helpers";
import {
    SET_SAA_SEGMENTFIELD_LIST,
    SET_LOADING_SAA_SEGMENTFIELDS,
    SET_SAVING_SAA_SEGMENTFIELD,
    SET_SELECTED_SAA_SEGMENTFIELD,
} from "../reducers/saaSegmentFields";
import {
    ISetSAASegmentFieldsList,
    ISetLoadingSAASegmentFieldList,
    ISetSavingSAASegmentField,
    ISetSelectedSAASegmentField,
    ISAASegmentField,
} from "../types/stores/saaSegmentFields";
import { notifyGreen } from "./notifyActions";

export const setSAASegmentFieldsList = (saaSegmentFieldList: Array<ISAASegmentField>): ISetSAASegmentFieldsList => ({
    type: SET_SAA_SEGMENTFIELD_LIST,
    saaSegmentFieldList,
});

export const setLoadingSAASegmentFieldsList = (isLoadingList: boolean): ISetLoadingSAASegmentFieldList => ({
    type: SET_LOADING_SAA_SEGMENTFIELDS,
    isLoadingList,
});

export const setSavingSAASegmentField = (isSaving: boolean): ISetSavingSAASegmentField => ({
    type: SET_SAVING_SAA_SEGMENTFIELD,
    isSaving,
});

export const setSelectedSAASegmentField = (selectedId: number): ISetSelectedSAASegmentField => ({
    type: SET_SELECTED_SAA_SEGMENTFIELD,
    selectedId,
});

export const getSAASegmentFieldListById =
    (templateId: number) =>
    (dispatch: Dispatch): void => {
        dispatch(setLoadingSAASegmentFieldsList(true));

        request("/SAASegmentField/GetSAATemplateFieldsById?advertiserId=" + templateId, 
            { credentials: "same-origin" }, dispatch)
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const result = data as unknown as { segmentFields: Array<ISAASegmentField> };
                dispatch(setSAASegmentFieldsList(result.segmentFields));
                dispatch(setLoadingSAASegmentFieldsList(false));
            })
            .catch(error => {
                dispatch(setSAASegmentFieldsList([]));
                dispatch(setLoadingSAASegmentFieldsList(false));
                h.error("Error getting SAA SegmentField List.", error);
            });
    };

export const getSAASegmentFieldList =
        () =>
        (dispatch: Dispatch): void => {
            dispatch(setLoadingSAASegmentFieldsList(true));
            return request(
                `/SAASegmentField/GetSAATemplateFields`,
                {
                    credentials: "same-origin",
                    method: "POST",
                },
                dispatch
            )
                .then(h.checkStatus)
                .then(h.toJson)
                .then(data => {
                    const response = data as unknown as {
                        success: boolean;
                        saaTemplateFields: Array<ISAASegmentField>;
                    };
                    dispatch(setLoadingSAASegmentFieldsList(false));
                    if (response.success) {
                        dispatch(setSAASegmentFieldsList(response.saaTemplateFields));
                    } else {
                        h.error("Error getting SAA SegmentField List.");
                    }
                })
                .catch(error => {
                    dispatch(setLoadingSAASegmentFieldsList(false));
                    h.error("Error getting SAA SegmentField List.", error);
                });
        };

export const updateSAASegmentField =
    (segmentFields: Array<ISAASegmentField>) =>
    (dispatch: Dispatch): void => {
        dispatch(setSavingSAASegmentField(true));
        request(
            "/SAASegmentField/UpdateSAATemplateFields",
            {
                credentials: "same-origin",
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    selectedSegmentFields: JSON.stringify(segmentFields),
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(() => {
                dispatch(setSavingSAASegmentField(false));
                dispatch(setSelectedSAASegmentField(0));
                dispatch(notifyGreen("SAA SegmentField Updated."));
            })
            .catch(error => {
                dispatch(setSavingSAASegmentField(false));
                h.error("Error updating SAA SegmentField.", error);
            });
    };
